import React, { useEffect, useRef } from 'react'
import { Dropdown } from 'bootstrap'
import { isAdmin as isAdminRole } from '../../../utils/userRoles'

export function UserActionsDropdown({
  userRow,
  user,
  impersonating,
  onMakeAdmin,
  onImpersonate,
  onDelete,
  onResetPassword,
  onEdit,
}) {
  const dropdownRef = useRef(null)
  const dropdownInstanceRef = useRef(null)

  useEffect(() => {
    if (dropdownRef.current && !dropdownInstanceRef.current) {
      try {
        dropdownInstanceRef.current = new Dropdown(dropdownRef.current, {
          autoClose: true,
          boundary: 'viewport',
        })
      } catch (error) {
        console.error('Failed to initialize dropdown:', error)
      }
    }

    return () => {
      if (dropdownInstanceRef.current) {
        try {
          dropdownInstanceRef.current.dispose()
          dropdownInstanceRef.current = null
        } catch (error) {
          console.error('Failed to dispose dropdown:', error)
        }
      }
    }
  }, [])

  const canMakeAdmin = !isAdminRole(userRow)
  const canImpersonate =
    !impersonating &&
    userRow.user_type !== 'admin' &&
    userRow.user_type !== 'owner' &&
    userRow.id !== user?.id
  const canDelete = userRow.user_type !== 'owner'
  const canResetPassword = user && user.user_type === 'owner'
  const canEdit =
    user &&
    user.user_type === 'owner' &&
    (userRow.user_type !== 'owner' || userRow.id === user.id)

  return (
    <div className="dropdown">
      <button
        ref={dropdownRef}
        className="btn btn-outline-secondary btn-sm dropdown-toggle"
        type="button"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          dropdownInstanceRef.current?.toggle()
        }}
        aria-expanded="false"
        style={{ minWidth: '80px' }}
      >
        Actions
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {canEdit && (
          <li>
            <button className="dropdown-item" onClick={() => onEdit(userRow)}>
              Edit User
            </button>
          </li>
        )}
        {canMakeAdmin && (
          <li>
            <button
              className="dropdown-item"
              onClick={() => onMakeAdmin(userRow.id)}
            >
              Make Admin
            </button>
          </li>
        )}
        {canImpersonate && (
          <li>
            <button
              className="dropdown-item"
              onClick={() => onImpersonate(userRow)}
              title="Login as this user for troubleshooting"
            >
              {impersonating ? 'Loading...' : 'Login as User'}
            </button>
          </li>
        )}
        {canDelete && (
          <li>
            <button
              className="dropdown-item text-danger"
              onClick={() => onDelete(userRow.id)}
            >
              Delete
            </button>
          </li>
        )}
        {canResetPassword && (
          <li>
            <button
              className="dropdown-item"
              onClick={() => onResetPassword(userRow)}
            >
              Reset Password
            </button>
          </li>
        )}
      </ul>
    </div>
  )
}

export function DesktopUserActions({
  userRow,
  user,
  impersonating,
  onMakeAdmin,
  onImpersonate,
  onDelete,
  onResetPassword,
  onEdit,
}) {
  return (
    <div className="d-flex gap-2">
      <button
        className="btn btn-sm btn-primary"
        onClick={() => onMakeAdmin(userRow.id)}
        disabled={isAdminRole(userRow)}
      >
        Make Admin
      </button>
      <button
        className="btn btn-sm btn-secondary"
        onClick={() => onImpersonate(userRow)}
        disabled={
          impersonating ||
          userRow.user_type === 'admin' ||
          userRow.user_type === 'owner' ||
          userRow.id === user?.id
        }
        title="Login as this user for troubleshooting"
      >
        {impersonating ? 'Loading...' : 'Login as User'}
      </button>
      <button
        className="btn btn-sm btn-danger"
        onClick={() => onDelete(userRow.id)}
        disabled={userRow.user_type === 'owner'}
      >
        Delete
      </button>
      {user && user.user_type === 'owner' && (
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => onResetPassword(userRow)}
        >
          Reset Password
        </button>
      )}
      {user &&
        user.user_type === 'owner' &&
        (userRow.user_type !== 'owner' || userRow.id === user.id) && (
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => onEdit(userRow)}
          >
            Edit
          </button>
        )}
    </div>
  )
}
